// Agendas por agente (spec 011): constantes e funcoes puras do seletor de agendas.

// Ferramentas do Capitao que usam agenda: so Cenarios com alguma delas mostram o seletor.
export const AGENDA_TOOL_IDS = [
  'agenda_availability',
  'agenda_book',
  'appointment_catalog',
  'appointment_availability',
  'appointment_create',
];

export const AGENT_TYPES = {
  SCENARIO: 'captain_scenario',
  PERSONA: 'ai_persona',
};

export const emptyScope = () => ({
  practitioner_ids: [],
  user_ids: [],
  conversation_assignee: false,
});

export const usesAgendaTools = tools =>
  (tools || []).some(tool => AGENDA_TOOL_IDS.includes(tool));

export const isEmptyScope = scope =>
  !scope ||
  (!scope.practitioner_ids?.length &&
    !scope.user_ids?.length &&
    !scope.conversation_assignee);

// Busca sem acento nem caixa: "jose" acha "José".
export const normalizeText = text =>
  String(text ?? '')
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase();

export const matchesSearch = (query, ...fields) => {
  const needle = normalizeText(query).trim();
  return !needle || fields.some(field => normalizeText(field).includes(needle));
};

const namesOf = (ids, items, idKey) =>
  (ids || [])
    .map(id => (items || []).find(item => item[idKey] === id)?.name)
    .filter(Boolean);

// Nomes das agendas escolhidas que ainda existem no catalogo (profissionais ativos, usuarios da conta).
export const summaryNames = (scope, catalog) => [
  ...namesOf(scope?.practitioner_ids, catalog?.practitioners, 'id'),
  ...namesOf(scope?.user_ids, catalog?.users, 'user_id'),
];

// Escolheu agendas, mas nenhuma delas esta mais ativa: o agente ficaria sem agenda.
export const hasNoActiveAgenda = (scope, catalog) => {
  const chosen =
    (scope?.practitioner_ids?.length || 0) + (scope?.user_ids?.length || 0);
  return chosen > 0 && summaryNames(scope, catalog).length === 0;
};
